var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'v-content',
    'container-fluid'
  ]},[_c('div',{staticClass:"row v-content__container py-4 py-sm-5 my-4 my-sm-5"},[(_vm.hasSidebar)?_c('div',{staticClass:"col-md-3 d-none d-md-flex"},[_vm._t("sidebar")],2):_vm._e(),_c('div',{staticClass:"col"},[_c('main',[_vm._t("default")],2)]),(!_vm.fullWidth)?_c('div',{staticClass:"col-md-1 col-lg-2 d-none d-md-flex"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }